import logo from 'src/images/firetv_logo_white.png';
import styles from './Logo.module.css';

const Logo = () => <img src={logo} alt="Logo" className={styles.logo} />;

export { Logo };
